import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Fecha', numeric: false, disablePadding: false, label: 'Fecha', show:true, fixed:false, width:150, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Celebracion', numeric: false, disablePadding: false, label: 'Celebracion', show:true, fixed:false, width:350, num:1, align:'left', fontSize:'16px', bolder:false, type:'text' },
    ];

    const variablesObject = {
        api:'/api/Feriados',
        apiFiltered:'/api/FeriadosbyEmpresa',
        apiMultiples:'/api/Feriados/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,
        label:'FERIADO',
        nameLocalStorage:'headersFeriadosYounet',
        order:'asc',
        orderBy:'Fecha',
        rowsPerPage:15,
        sumWidth:660,
        title:'FERIADOS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;